<template>
  <div class="new-docs">
    <h4 style="padding-top: 15px;">必须提供的索赔资料：</h4>
    <p class="doc_text">1、营业执照彩色复印件</p>
    <p class="doc_text">2、法定代表人身份证复印件（非中华人民共和国公民请提交有效护照彩色复印件）</p>
    <p class="doc_text">3、授权委托书和代理人身份证复印件和非商户授权交易补偿申请表（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）</p>
    <p class="doc_text">4、向公安机关报案的相关证明（报案或立案证明）</p>
    <p class="doc_text">5、索赔人出险期间手机设备在公安机关的备案数据</p>
    <p class="doc_text">6、索赔人被盗账户信息截屏</p>
    <p class="doc_text">7、被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）</p>
    <p class="doc_text">8、被盗账户挂失证明（信息截屏，包含挂失日期等）</p>
    <p class="doc_text">9、其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。</p>
    <h4 >如有可提供的索赔资料：</h4>
    <p class="doc_text">1、被盗账户近半年交易数据（如有）</p>
    <p class="doc_text">2、涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）</p>
  </div>
</template>

<script>
export default {
  name: 'newdocs',
}
</script>

<style scoped>
.new-docs h4{
  margin: 5px 15px;
}

.new-docs .doc_text {
  margin-top: 0px;
  margin-bottom: 5px;
  padding-left: 15px;
}
</style>



// WEBPACK FOOTER //
// docs.vue?fb19af44